import { FloraButton, styled } from '@grupoboticario/flora-react';

export const Step = {
  Component: styled('div', {
    display: 'flex',
    button: {
      border: `solid 2px transparent`,
      color: '$disabledBackground',
    },
    '&[data-active="true"]': {
      button: {
        border: `solid 2px $nonInteractiveEmphasis`,
        color: '$nonInteractiveEmphasis',
      },
    },
    '&[data-last="false"]': {
      display: 'flex',
      alignItems: 'center',
      '&:after': {
        background: '$disabledBackground',
        content: '""',
        display: 'inline-block',
        height: 'calc($1 / 2)',
        width: '$22',
        '@desktop': {
          width: 'calc($15 * 2)',
        },
      },
    },
    '&[data-completed="true"]': {
      button: {
        color: '$nonInteractiveEmphasis',
      },
      '&:after': {
        background: '$nonInteractiveEmphasis',
      },
    },
  }),

  Title: styled('div', {
    left: '50%',
    marginTop: '$2',
    position: 'absolute',
    top: '100%',
    transform: 'translateX(-50%)',
  }),

  ButtonIcon: styled(FloraButton, {
    cursor: 'default',
    width: '32px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '50%',
    gap: 0,
    boxShadow: '$downSoft',

    '&[data-size="small"]': {
      padding: 0,
      height: '32px',
    },

    '&[data-button-step="true"]': {
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  }),

  Content: styled('div', {
    position: 'relative',
  }),
};
